import { useState } from 'react';
import { Dialog as DialogPrimitive } from 'radix-ui';

import IntroReel from './IntroReel';
import VisuallyHidden from '@/components/VisuallyHidden/VisuallyHidden';
import reelThumbnail from '@/assets/images/intro-reel/welcome-mum-bg.jpg';

/**
 * The Meet Mia card and the reel it opens (GIFTWEB-28).
 *
 * Built on a Radix Dialog with the card as its trigger, which is what makes
 * Escape close the overlay *and* return focus to the card (AC 3), and what
 * locks background scroll while it is open (AC 8). A hand-rolled overlay would
 * have to reimplement both.
 */
function MeetMia() {
  const [open, setOpen] = useState(false);

  return (
    <DialogPrimitive.Root open={open} onOpenChange={setOpen}>
      <DialogPrimitive.Trigger asChild>
        <button
          type='button'
          className='flex w-full items-center gap-3.5 rounded-2xl border border-[#eceae3] bg-[#faf9f6] p-3 text-left'
        >
          <span className='relative block size-[88px] shrink-0 overflow-hidden rounded-xl bg-[#0c0c0c]'>
            <img
              src={reelThumbnail}
              alt=''
              className='absolute inset-0 size-full object-cover'
            />
            <span className='absolute inset-0 bg-[rgba(16,32,25,0.28)]' />
            <span
              aria-hidden='true'
              className='absolute top-1/2 left-1/2 flex size-[34px] -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-white/95'
            >
              <svg width='14' height='14' viewBox='0 0 24 24' fill='#1a201d'>
                <path d='M8 5v14l11-7z' />
              </svg>
            </span>
          </span>
          <span className='min-w-0 flex-1'>
            <span className='block text-[15px] font-bold text-[#1a201d]'>
              Meet Mia
            </span>
            <span className='mt-0.5 block text-[12.5px] leading-[1.4] text-[#5a635e]'>
              A short introduction to Mia
            </span>
          </span>
          <svg
            width='18'
            height='18'
            viewBox='0 0 24 24'
            fill='none'
            stroke='#b3bcb6'
            strokeWidth='2.4'
            strokeLinecap='round'
            strokeLinejoin='round'
            aria-hidden='true'
            className='shrink-0'
          >
            <path d='M9 6l6 6-6 6' />
          </svg>
        </button>
      </DialogPrimitive.Trigger>

      <DialogPrimitive.Portal>
        <DialogPrimitive.Overlay className='fixed inset-0 z-50 bg-black/80' />
        {/* AC 9 — full-bleed on mobile, a centred panel with a cap on desktop. */}
        <DialogPrimitive.Content
          className='fixed inset-0 z-50 overflow-hidden bg-[#0c0c0c] lg:top-1/2 lg:left-1/2 lg:h-[min(844px,92vh)] lg:w-[min(390px,92vw)] lg:-translate-x-1/2 lg:-translate-y-1/2 lg:rounded-[28px]'
          aria-describedby={undefined}
        >
          <DialogPrimitive.Title asChild>
            <VisuallyHidden>Meet Mia — a short introduction</VisuallyHidden>
          </DialogPrimitive.Title>

          {open && <IntroReel onFinish={() => setOpen(false)} />}
        </DialogPrimitive.Content>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  );
}

export default MeetMia;
